import React, { ChangeEvent } from "react";
import { Form, InputGroup } from "react-bootstrap";
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const EmailControl: React.FC<ControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        onChange(e.target.value);
    }

    let v = '';
    if (value)
        v = value;

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    return (
        <div style={{ width: width }}>
            <InputGroup>
                <InputGroup.Text>
                    <i className="fa fa-at"></i>
                </InputGroup.Text>
                <Form.Control type='text' name={name} value={v} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} />
            </InputGroup>
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default EmailControl;